import authAxios from "@/utilities/authAxios.js";
import handleError from "@/utilities/handleError.js";
import { rejectOnAxiosError } from "@/utilities/error-handling/handleAxiosError.js";

async function getProjectsAndWarehouses() {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/projects-and-warehouses")
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function getUserPreferences() {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/preferences")
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function updateUserPreference(body) {
  return authAxios.put(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/userpreference", body)
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

async function mediaForUserByEntity(params, errorOptions = { showErrors: true }) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/media", { params })
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

async function userDetails(userId) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user" + `/${userId}`)
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function updateUser(userData) {
  return authAxios.put(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/", userData)
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function userSearch(params) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/search", {params})
  .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function getNoteTypes() {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/notes/types")
    .then(response => response.data.map(d => ({ ...d, isPublished: d.value === "WHQ"}))).catch(error => { handleError(error); return { httpError: true }; });
}

async function notesForUserbyEntity(orderId, entityClass) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/notes", { params: { entityId: orderId, entityClass } })
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function createNote(params, errorOptions = { showErrors: true }) {
  return authAxios.post(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/note", params) // params must include ownerClazz property
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

async function editNote(params) {
  return authAxios.put(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/note", params) // params must include ownerClazz property
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function deleteNote(noteId) {
  return authAxios.delete(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/note", { params: { entityId: noteId } })
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function mediaTypes() {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/media/types")
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

async function getUsersByRole(params, handleError, customFallbackErrorMessage) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/user/role/search", { params })
    .then(response => response.data, (err) => rejectOnAxiosError(err, customFallbackErrorMessage || "An error occurred while fetching users by role.", handleError));
} 

export {
  getProjectsAndWarehouses,
  getUserPreferences,
  updateUserPreference,
  mediaForUserByEntity,
  userDetails,
  updateUser,
  userSearch,
  getNoteTypes,
  notesForUserbyEntity,
  createNote,
  editNote,
  deleteNote,
  mediaTypes,
  getUsersByRole
}